<div class="maintenance-container">
  <div class="maintenance-content">
    <div class="text-wrapper">
      <h1>We'll be back soon!</h1>
      <p>
        We're doing some essential maintenance and will be back{{ dateString }} at {{ endTime | timeFormat }}.
      </p>
      <p *ngIf="impactCallCentre">
        This affects our online service and call centre equally — our teams won't be able to arrange a replacement until we're back up.
      </p>
    </div>
    <div class="image-wrapper">
      <img src="/assets/images/error-icon.png" alt="maintenance" />
    </div>
  </div>
</div>
